import React from 'react';

import { IAssetFile } from '@interfaces/assets/asset';

import File from './File';

import styles from './FilesList.module.scss';

interface IFilesListProps {
	files: Array<IAssetFile>;
	handleRemoveFile?: (fileId: string) => void;
	maxWidth?: number;
	isViewMode?: boolean;
	isDeleteInViewMode?: boolean;
}

const FilesList = ({
	files,
	handleRemoveFile,
	maxWidth = 170,
	isViewMode = false,
	isDeleteInViewMode = false,
}: IFilesListProps) => {
	return (
		<div className={styles.FilesListContainer}>
			{!!files?.length && files.map(file => (
					<File
						key={file.id}
						file={file}
						handleRemoveFile={handleRemoveFile}
						isDeleteInViewMode={isDeleteInViewMode}
						isViewMode={isViewMode}
						maxWidth={maxWidth}
					/>
				),
			)}
		</div>
	);
};

export default FilesList;
